import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { KeyboardArrowDownOutlined, Sort, UploadFile } from '@mui/icons-material';

interface ProspectHeaderProps {
    setUploadProspects: (value: boolean) => void;
    searchProspectsHandler: (value: 'ls' | 'd7') => void;
    prospectLength: number;
    sort: boolean;
    setSort: (value: boolean) => void;
    loading: boolean;
}

const ProspectHeaderComponent = ({ setUploadProspects, searchProspectsHandler, prospectLength, sort, setSort, loading }: ProspectHeaderProps) => {
    const { loaders } = useSelector((state: RootState) => state.prospect);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleSearchClick = (type: 'ls' | 'd7') => {
        searchProspectsHandler(type);
        handleMenuClose();
    };

    return (
        <Box>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h5" fontWeight="bold" color="rgba(111,118,126,1)">
                    Prospects
                </Typography>
                <Box display="flex" gap={1}>
                    <Button
                        variant="outlined"
                        startIcon={<UploadFile />}
                        onClick={() => setUploadProspects(true)}
                        disabled={loading || loaders.isSearching}
                    // sx={{
                    //     display: 'none'
                    // }}
                    >
                        Upload Prospects
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleButtonClick}
                        disabled={loading || loaders.isSearching}
                        endIcon={<KeyboardArrowDownOutlined />}
                    >
                        {loaders.isSearching ? 'Loading Suggestions' : 'Find Prospects'}
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleMenuClose}
                        MenuListProps={{
                            'aria-labelledby': 'add-pipeline-button'
                        }}
                    >
                        <MenuItem onClick={() => handleSearchClick('d7')}>
                            Search with Source 1
                        </MenuItem>
                        <MenuItem onClick={() => handleSearchClick('ls')}>
                            Search with Source 2
                        </MenuItem>
                    </Menu>
                </Box>
            </Box>

            {/* Recent Searches */}
            <Box display="flex" justifyContent="space-between" mb={2}><Typography variant="subtitle1" fontWeight="bold" color="rgba(111,118,126,1)" >
                Recent Searches - {prospectLength}
            </Typography>
                <Button
                    variant={sort ? 'outlined' : 'contained'}
                    color={sort ? 'secondary' : 'primary'}
                    startIcon={<Sort />}
                    onClick={() => setSort(!sort)}
                    disabled={loading || loaders.isSearching}
                >
                    Sort
                </Button>
            </Box>
        </Box>
    );
};

export default ProspectHeaderComponent;